angular.module('cn')
.service('promiseCache', [
  function() {

    var PromiseCache = function(fn, seconds) {
      var cache = {};
      var date;
      this.get = function() {
        var tte = new Date();
        tte.setDate(tte.getDate() + seconds / 60 * 60 * 24);
        if (cache && date < tte) {
          return cache;
        }
        date = new Date();
        cache = fn();
        return cache;
      };
    };

    this.create = function(fn, seconds) {
      seconds = seconds || 60;
      return new PromiseCache(fn, seconds);
    };
  }
]);



// WEBPACK FOOTER //
// ./src/lib/promisecache.js